import { Box } from "@material-ui/core";
import React from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import { convertToBase64 } from "../../../../../../utils/convertToBase64";
import { fakeFormsDataKYCManual } from "../../../../../../utils/fakeFormsData";
import IconTitle from "../../../../../shared/components/IconTitle";
import { UploadDocIdPictureButton } from "../../../../../shared/components/UploadDocIdPictureButton";
import UploadDocIdPictureDialog from "../../../../../shared/components/UploadDocIdPictureDialog";
import Text from "../../../../../shared/components/Text";
import { docIdSide } from "../../config";
import MainButton from "../../../../../shared/components/MainButton";
import { assetIds, ThemedAsset } from "nemuru-components";
import { useTheme } from "@material-ui/styles";
import { developOptions } from "../../../../../../config/developOptions";

export default function AdditionalDataDocIdPictureNieEu({
  onSubmitForm,
  data,
}) {
  const { palette } = useTheme();

  const [state, setState] = React.useState({
    imageData: developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES
      ? {
          passportFront:
            fakeFormsDataKYCManual?.DOC_ID_PICTURE_NIE_EU.passportFront,
        }
      : data
      ? data
      : {},
    imageCurrentSide: {},
    openDialog: false,
  });

  const { imageData, imageCurrentSide, openDialog } = state;

  const handleClick = (side) => {
    setState((s) => ({
      ...s,
      openDialog: true,
      imageCurrentSide: side,
    }));
  };

  const handleClose = () => {
    setState((s) => ({
      ...s,
      openDialog: false,
    }));
  };

  const handleDelete = (id) => {
    let filteredImages = {};
    Object.keys(imageData).filter((key) => {
      if (key !== id) {
        return (filteredImages = {
          ...filteredImages,
          [key]: imageData[key],
        });
      } else {
        return;
      }
    });
    setState((s) => ({
      ...s,
      imageData: filteredImages,
    }));
  };

  const onUploadImage = (e) => {
    const value = e.target.files[0];
    const name = e.target.name;
    if (value) {
      convertToBase64(value, (result) => {
        setState((s) => ({
          ...s,
          imageData: {
            ...s.imageData,
            [name]: {
              result,
              file: value,
              name: value.name,
              size: value.size,
              type: value.type,
            },
          },
          imageCurrentSide: null,
        }));
      });
    }
  };

  React.useEffect(() => {
    if (imageCurrentSide === null) {
      setState((s) => ({ ...s, openDialog: false }));
    }
  }, [imageCurrentSide]);

  return (
    <>
      <Box className="appear-anim" flex={0}>
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_PASSPORT}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="ID" />}
          subtitle={<Text tId="IMAGE_ID_NIE_EU" />}
        />
      </Box>
      <Box
        flex={0}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        className="appear-anim"
      >
        <UploadDocIdPictureButton
          currentDocIdSide={docIdSide.PASSPORT_FRONT}
          imageData={imageData}
          handleClick={handleClick}
          handleDelete={handleDelete}
        />
      </Box>
      <Box flex={0.3} mb={4} />
      <MainButton
        disabled={Object.keys(imageData).length < 1}
        onClick={() => onSubmitForm({ ...imageData })}
      >
        <Text tId="CONTINUE" />
      </MainButton>
      {imageCurrentSide && (
        <UploadDocIdPictureDialog
          open={openDialog}
          onClose={() => handleClose()}
          onUploadImage={onUploadImage}
          currentDocIdSide={imageCurrentSide}
        />
      )}
    </>
  );
}
